import { Box, Flex, Grid, GridItem } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import SelectWalletNetworksModal from '../Modals/ConnectWalletModal';
import ContractInteractionModal from '../Modals/ContractInteractionModal';
import CreateTransactionModal from '../Modals/CreateTransactionModal';
import CreateTokenModal from '../Modals/CreateTokenModal';
import FailedModal from '../Modals/FailedModal';
import SendTokensModal from '../Modals/SendTokensModal';
import TokenDetailsModal from '../Modals/TokenDetailsModal';
import FundWalletModal from '../Modals/FundWalletModal';
import CreateTransactionWizard from '../Modals/CreateTransactionWizard';
import FAQDrawer from '../Modals/FAQDrawer';
import AboutModal from '../Modals/AboutModal';
import NotificationDrawer from '../Modals/NotificationDrawer';
import NotificationSettingsDrawer from '../Modals/NotificationSettingsDrawer';
import AddressBookDrawer from '../Modals/AddressBookDrawer';
import PrivateNetworksDrawer from '../Modals/PrivateNetworksDrawer';
import KeystoreAuthDrawer from '../Modals/KeystoreAuthDrawer';
import ChangePasswordModal from '../Modals/ChangePasswordModal';
import Footer from '../Footer';
import { Header } from './Header';
import { customNetworksEnabled } from '../../utils/customNetworks';

const Layout = () => {
  return (
    <>
      <FailedModal />
      <SendTokensModal />
      <CreateTransactionModal />
      <ContractInteractionModal />
      <SelectWalletNetworksModal />
      <CreateTokenModal />
      <TokenDetailsModal />
      <FundWalletModal />
      <CreateTransactionWizard />
      <FAQDrawer />
      <AboutModal />
      <NotificationDrawer />
      <NotificationSettingsDrawer />
      <AddressBookDrawer />
      {customNetworksEnabled() && (
        <>
          <PrivateNetworksDrawer />
          <KeystoreAuthDrawer />
        </>
      )}
      <ChangePasswordModal />
      <Grid
        templateAreas={`
          "header header"
          "main main"
        `}
        gridTemplateRows={'64px 1fr'}
        gridTemplateColumns={'100% 1fr'}
        height="100%"
      >
        <GridItem area="header" zIndex={10}>
          <Header />
        </GridItem>
        <GridItem
          id="content"
          display="flex"
          flexDirection="column"
          area="main"
          bg="#FAFAFA"
          overflowY="scroll"
        >
          <Flex
            flex={1}
            order={2}
            direction="column"
            alignItems="center"
            py={3}
            px={{ base: 6, md: 12 }}
          >
            <Outlet />
          </Flex>
          <Box order={3}>
            <Footer />
          </Box>
        </GridItem>
      </Grid>
    </>
  );
};

export default Layout;
